import React from 'react';
import PropTypes from 'prop-types';

import { SubSection, SubSectionTitle, Text } from './styles';

export default function Bio({ blurb }) {
  if (!blurb || blurb.trim().length === 0) {
    return null;
  }

  return (
    <SubSection>
      <SubSectionTitle>Bio</SubSectionTitle>
      <Text>{blurb}</Text>
    </SubSection>
  );
}

Bio.propTypes = {
  blurb: PropTypes.string,
};

Bio.defaultProps = {
  blurb: null,
};
